/* eslint-disable */

import { Button, Form, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";

import { isBefore } from "date-fns";

import { FaEye, FaEject, FaCircleExclamation } from "react-icons/fa6";

const NotesEditor = (props) => {
  const dateFormat = "MM/dd/yyyy HH:mm";

  const problem = props.problem;
  const outage = props.outage;

  const postIt = props.postIt;
  const refreshNotes = props.refresh;

  const setNoteContents = props.setNoteContents;
  const noteContents = props.noteContents;

  const handleClick = (e) => {
    // Generated by GitHub Copilot
    // Added defensive checks per US1761821 to prevent undefined errors
    if (!problem || !problem.number) {
      console.error("Problem is undefined or missing number property", problem);
      return;
    }
    if (!outage || !outage.number) {
      console.error("Outage is undefined or missing number property", outage);
      return;
    }

    postIt(problem.number, outage.number, noteContents).then((res) => {
      setNoteContents({
        ...noteContents,
        message: "",
        created: new Date(),
        id: "",
        private: false,
        important: false,
        pir: false,
      });
      refreshNotes();
    });
  };

  return (
    <>
      <Row>
        <Col>
          <div>
            <h3>{noteContents.id == "" ? "Create Note" : `Edit Note`}</h3>
          </div>
        </Col>
      </Row>

      <Form>
        <Row>
          <Col xs={12} sm={12} md={12} lg={7} xl={7}>
            <Form.Control
              data-testid="note-textarea"
              size="md"
              type="text"
              as="textarea"
              style={{ height: "100px" }}
              value={noteContents.message}
              readOnly={false}
              onChange={(e) => {
                setNoteContents({
                  ...noteContents,
                  message: e.target.value,
                });
              }}
              required
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  !e.ctrlKey && handleClick();

                  e.ctrlKey &&
                    setNoteContents({
                      ...noteContents,
                      message: noteContents.message + `\n`,
                    });
                }
              }}
            ></Form.Control>
            <Form.Text className="text-muted">
              Press Enter to submit, Ctrl-Enter to add a newline (like slack!)
            </Form.Text>
          </Col>
          <Col xs={12} sm={12} md={12} lg={5} xl={5}>
            <Row>
              <Col>
                <DatePicker
                  selected={new Date(noteContents.created)}
                  onChange={(e) => {
                    setNoteContents({ ...noteContents, created: e });
                  }}
                  defaultValue={new Date()}
                  showTimeSelect
                  dateFormat={dateFormat}
                  timeFormat="HH:mm"
                  timeIntervals={5}
                  filterDate={(d) => {
                    return isBefore(d, new Date());
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Check
                  data-testid="note-private-checkbox"
                  type="switch"
                  id="private"
                  label="Private"
                  checked={noteContents.private}
                  onChange={(e) => {
                    setNoteContents({
                      ...noteContents,
                      private: e.target.checked,
                    });
                  }}
                  // disabled={loading}
                />
                <Form.Check
                  data-testid="note-important-checkbox"
                  type="switch"
                  id="important"
                  label="Important"
                  checked={noteContents.important}
                  onChange={(e) => {
                    setNoteContents({
                      ...noteContents,
                      important: e.target.checked,
                    });
                  }}
                />
                <Form.Check
                  data-testid="note-pir-checkbox"
                  type="switch"
                  id="pir"
                  label="PIR item"
                  checked={noteContents.pir}
                  onChange={(e) => {
                    setNoteContents({
                      ...noteContents,
                      pir: e.target.checked,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  variant="warning"
                  onClick={() => {
                    setNoteContents({
                      ...noteContents,
                      message: "",
                      edit: false,
                      created: new Date(),
                      id: "",
                    });
                  }}
                >
                  <FaEject /> &nbsp; Cancel
                </Button>
                <Button
                  data-testid="note-submit-button"
                  variant={noteContents.private ? "primary" : "danger"}
                  onClick={handleClick}
                  disabled={
                    !problem || !problem.number || !outage || !outage.number
                  }
                >
                  {noteContents.important ? (
                    <>
                      <FaCircleExclamation /> &nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  {noteContents.private ? <></> : <FaEye />}
                  &nbsp; {noteContents.edit ? "Update" : "Post"}
                  {noteContents.private ? " Privately" : " Publicly"}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default NotesEditor;
